
export { globalAPI } from "/__w/wiggot-web/wiggot-web/packages/apis/new-apis/global-api.ts"